import styled, { css } from 'styled-components';
import { switchProp, theme } from 'styled-tools';

import Burger from '@/components/ui/icons/Burger';
import { Row } from 'react-styled-flexboxgrid';
import breakpoint from 'styled-components-breakpoint';

const StyledNav = styled.nav<{
  fixed?: boolean;
  isTransparent?: boolean;
  noMargin?: boolean;
}>`
  position: ${(props) => (props.fixed ? 'fixed' : 'relative')};
  margin-bottom: ${(props) => (props.noMargin || props.fixed ? '0' : '40px')};
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  transition: all 0.5s;

  ${switchProp('isTransparent', {
    true: css`
      background-color: transparent;
      border-bottom: 1px solid transparent;
    `,
    false: css`
      background-color: ${theme('colors.white')};
      border-bottom: 1px solid ${theme('colors.titleGray')};
    `,
  })}
`;

const MainRow = styled(Row)<{ isTransparent?: boolean }>`
  padding-top: ${(props) => (props.isTransparent ? '20px' : '10px')};
  padding-bottom: ${(props) => (props.isTransparent ? '20px' : '10px')};
  padding-left: 1rem;
  padding-right: 1rem;
  transition: all 0.5s;

  ${breakpoint('md')`
    padding-left: 2rem;
    padding-right: 2rem;
  `}

  ${breakpoint('lg')`
    padding-left: 4rem;
    padding-right: 4rem;
  `}
`;

const StyledLink = styled.a<{ isTransparent?: boolean }>`
  color: ${(props) => (props.isTransparent ? theme('colors.white') : theme('colors.blue'))} !important;
  transition: all 0.5s;
  display: inline-block;
`;

const BurgerButton = styled.button<{ isTransparent?: boolean }>`
  outline: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.5s;
  color: ${(props) => (props.isTransparent ? theme('colors.white') : theme('colors.blue'))};

  :focus,
  :hover {
    outline: none;
    color: ${theme('colors.orange')};
  }
`;

const StyledBurger = styled(Burger)`
  width: 36px;
  height: 36px;
  display: inline-block;
`;

const DrawerOverlay = styled.div<{ $open?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 1200;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${(props) => (props.$open ? 1 : 0)};
  visibility: ${(props) => (props.$open ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
`;

const DrawerPanel = styled.aside<{ $open?: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1201;
  max-width: 100%;
  height: 100%;
  background-color: ${theme('colors.white')};
  overflow-y: auto;
  transform: translateX(${(props) => (props.$open ? '0' : '100%')});
  transition: transform 0.3s ease;
`;

export { StyledNav, MainRow, StyledLink, BurgerButton, StyledBurger, DrawerOverlay, DrawerPanel };
